import { createAction } from '@reduxjs/toolkit';
export const listMarket = createAction('market/list');
